import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchTenantList = ({commit}) => {

    axios.get('/appAdmin/tenant/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setTenantList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchTenantData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/tenant/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setTenantData', res.data.response)   
            router.push('/tenants/form/')
            
        } else {
            commit('resetTenantData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitTenantData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push('/tenants')
            } else {
                dispatch('fetchTenantData', { id: payload.id})
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateTenantContact = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/contact/updateTenantContact.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteTenantContact = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/contact/deleteTenantContact.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateTenantDiscussion = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/discussion/updateTenantDiscussion.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const updateShopWhatsApp = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/updateShopWhatsApp.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const deleteTenantDiscussion = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/tenant/discussion/deleteTenantDiscussion.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const startSession = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/whatsApp/startSession.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchWhatsAppLicenseList', {type: 1})
        } else {
            console.log(JSON.stringify(res.data))
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const stopWhatsAppSession = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/whatsApp/stopSession.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        } else {
            console.log(JSON.stringify(res.data))
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const createNewWhatsAppSession = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/whatsApp/createSession.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchTenantData', { id: payload.tenant_id})
        } else {
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/tenants/actions.js